/**
 * whether to exclude meta tags from the page
 * @param path The request url path
 * @returns true or false depending on whether the path should exclude metatags
 */
export function excludeMetatags(path: string | undefined) {
    if (!path) return false
    return path.startsWith("/calculators/")
}
